import {
  REPORT_HISTORY_SEARCH,
  REPORT_HISTORY_SEARCH_SUCCESS,
  REPORT_HISTORY_SEARCH_FAILURE,
  REPORT_HISTORY_CLEAR,
  REPORT_HISTORY_SET_SEND_STATUS,
  REPORT_HISTORY_SET_SEND_STATUS_SUCCESS,
  REPORT_HISTORY_SET_SEND_STATUS_FAILURE,
  REPORT_HISTORY_GET_SEND_FAILS_SUM,
  REPORT_HISTORY_GET_SEND_FAILS_SUM_SUCCESS,
  REPORT_HISTORY_GET_SEND_FAILS_SUM_FAILURE
} from './mutation-types'

export default {
  state: {
    reportHistories: null,
    reportHistoriesCurrentPage: null,
    reportHistoriesNextPageNumber: null,
    reportHistoriesTotalCount: 0,
    reportHistoriesErrorCount: 0,
    reportHistoriesUnsendCount: 0,
    searchParams: null
  },
  getters: {
    reportHistories: state => {
      return state.reportHistories
    },
    reportHistoriesNextPageNumber: state => {
      return state.reportHistoriesNextPageNumber
    },
    reportHistoriesTotalCount: state => {
      return state.reportHistoriesTotalCount
    },
    reportHistoriesErrorCount: state => {
      return state.reportHistoriesErrorCount
    },
    reportHistoriesUnsendCount: state => {
      return state.reportHistoriesUnsendCount
    },
    reportHistoriesCurrentPage: state => {
      return state.reportHistoriesCurrentPage
    },
    reportHistoriesSearchParams: state => {
      return state.searchParams
    }
  },
  actions: {
    [REPORT_HISTORY_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/report_sends'
      var loadparams = true
      var data = {}
      var callback = () => {}

      if (params) {
        if (params.loadparams) {
          loadparams = params.loadparams
        }
        if (params.callback) {
          callback = params.callback
        }

        if (params.clear) {
          state.reportHistories = null
          state.reportHistoriesCurrentPage = null
          state.reportHistoriesNextPageNumber = null
          state.reportHistoriesTotalCount = 0
          // state.reportHistoriesErrorCount = 0
          // state.reportHistoriesUnsendCount = 0
        }
        state.searchParams = params.data
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_HISTORY_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(REPORT_HISTORY_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [REPORT_HISTORY_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(REPORT_HISTORY_CLEAR)
      }, sleep)
    },
    [REPORT_HISTORY_SET_SEND_STATUS] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }

      dispatch('apiPost', {url: '/report_sends/save', data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(REPORT_HISTORY_SET_SEND_STATUS_FAILURE, res.data)
            } else {
              commit(REPORT_HISTORY_SET_SEND_STATUS_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [REPORT_HISTORY_GET_SEND_FAILS_SUM] ({dispatch, state, commit}, params) {
      var url = '/report_sends/get_send_fails_sum'
      var data = {}
      if (params) {
        data = params.data
        if (params.clear) {
          state.reportHistoriesErrorCount = 0
        }
      }
      dispatch('apiGet', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_HISTORY_GET_SEND_FAILS_SUM_FAILURE, res.data)
          } else {
            commit(REPORT_HISTORY_GET_SEND_FAILS_SUM_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [REPORT_HISTORY_SEARCH_FAILURE] (state, data) {
      console.log('REPORT_HISTORY_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [REPORT_HISTORY_SEARCH_SUCCESS] (state, params) {
      console.log('REPORT_HISTORY_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      if (reSearch) {
        // 再検索
        state.reportHistories = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.reportHistoriesNextPageNumber = null
        }
      } else {
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.reportHistories = state.reportHistories.concat(data.data)
          state.reportHistoriesCurrentPage = data.meta['current-page']
        } else {
          state.reportHistories = data.data
          state.reportHistoriesCurrentPage = 1
        }

        if (data.meta && data.meta['next-page']) {
          state.reportHistoriesNextPageNumber = data.meta['next-page']
        } else {
          state.reportHistoriesNextPageNumber = null
        }
      }

      // 検索件数を取得
      state.reportHistoriesTotalCount = 0
      if (data.meta && data.meta['total-count']) {
        state.reportHistoriesTotalCount = data.meta['total-count']
      }

      // エラー履歴の件数を取得
      state.reportHistoriesErrorCount = 0
      if (data.meta && data.meta['report-counts']['error']) {
        state.reportHistoriesErrorCount = data.meta['report-counts']['error']
      }
      // 未送信履歴の件数を取得
      state.reportHistoriesUnsendCount = 0
      if (data.meta && data.meta['report-counts']['unsend']) {
        state.reportHistoriesUnsendCount = data.meta['report-counts']['unsend']
      }

      if (params.callback) {
        params.callback()
      }
    },
    [REPORT_HISTORY_CLEAR] (state) {
      state.reportHistories = null
    },
    [REPORT_HISTORY_SET_SEND_STATUS_FAILURE] (state) {
      console.log('REPORT_HISTORY_SET_SEND_STATUS_FAILURE')
    },
    [REPORT_HISTORY_SET_SEND_STATUS_SUCCESS] (state, data) {
      console.log('REPORT_HISTORY_SET_SEND_STATUS_SUCCESS')
      if (data.callback != null) {
        data.callback()
      }
    },
    [REPORT_HISTORY_GET_SEND_FAILS_SUM_FAILURE] (state) {
      console.log('REPORT_HISTORY_GET_SEND_FAILS_SUM_FAILURE')
    },
    [REPORT_HISTORY_GET_SEND_FAILS_SUM_SUCCESS] (state, data) {
      console.log('REPORT_HISTORY_GET_SEND_FAILS_SUM_SUCCESS')
      if (data['fails']) {
        state.reportHistoriesErrorCount = data['fails']
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report-history.js